import {
    Autocomplete,
    Box,
    Button,
    Dialog,
    DialogContent,
    DialogTitle,
    InputAdornment,
    TextField,
    Typography,
    Grid
  } from "@mui/material";
  import React, { useEffect, useState } from "react";
  import PushPinIcon from "@mui/icons-material/PushPin";
  import Notify from "../../../Notify";
  import { getData, putData } from "../../../../services/library";

function AnularPedido(props) {
    const [notificacion, setNotificacion] = useState({
        open: false,
        mensaje: "",
        severity: "",
        color: "",
      });
      const [datosformulario, setDatosformulario] = useState(props.dataPedido);
      const [disBtn, setDisBtn] = useState(false)
        const [datosPedido, setdatosPedido] = useState({
          obs_anulado: "",
        });

      async function guardarAnulado(e) {
        setDisBtn(true);
        putData(
          e,
          "/envasado_pedidos/" + datosformulario.id,
          {
            estado: 271,
            obs_anulado: datosPedido.obs_anulado
          },
          setNotificacion
        );
      }

          const almacenar = (e) => {
    setdatosPedido({
      ...datosPedido,
      [e.target.name]: e.target.value,
    });
  };

  // useEffect(() => {
  //   if (datosPedido.obs_anulado !== "") {
  //     setDisBtn(false)
  //   }
  // }, [datosPedido.obs_anulado])
  
    
      return (
        <div>
          {notificacion && notificacion.open ? (
            <Notify
              mensaje={notificacion.mensaje}
              open={notificacion.open}
              color={notificacion.color}
              handleClose={() => {
                props.setOpen(false);
              }}
              severity={notificacion.severity}
            />
          ) : null}
          <Dialog
            fullWidth
            open={props.open}
            onClose={() => props.setOpen(false)}
            maxWidth="sm"
          >
            <Box justifyContent="center" backgroundColor="#1F618D">
              <DialogTitle>
                <Typography variant="h6" align="center" color="#ffffff">
                  Anular Pedido N° {datosformulario.id}
                </Typography>
              </DialogTitle>
            </Box>
            <DialogContent sx={{alignContent:"center"}}>
              {/* <Typography textAlign={"center"}>
                  ¿Desea Marcar como Anulado el Pedido N° {datosformulario.id}?
              </Typography> */}
              <Grid container>
                          <Grid item xs={12}>
                            <TextField
                              label="Observaciones"
                              name="obs_anulado"
                              size="small"
                              focused
                              required
                              fullWidth
                              autoComplete="off"
                              value={datosPedido.obs_anulado}
                              onChange={almacenar}
                            />
                          </Grid>
                        </Grid>
              <Grid
                mt={1}
                container
                direction="row"
                justifyContent="space-between"
                alignItems="center"
              >
                <Button
                  variant="contained"
                  onClick={() => props.setOpen(false)}
                  color="error"
                >
                  Volver
                </Button>
                <Button
                  disabled={disBtn || datosPedido.obs_anulado === ""}
                  variant="contained"
                  onClick={guardarAnulado}
                  color="success"
                >
                  Guardar
                </Button>
              </Grid>
            </DialogContent>
          </Dialog>
        </div>
      );
}

export default AnularPedido